import React from 'react'
import tellko_logo from '../images/tellko_logo.png';
import footer_img from '../images/footer_img.png';

export default function PageHeader() {
    return(
        <div className="container-fluid p-0 mt-4 mb-0">
          <div className="container">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                 <p className='mb-0 copy_right' style={{color: '#ffffff', fontSize: '13px'}}>Copyright © 2025 All rights reserved.</p>
                 <p className='mt-0 mb-0' style={{color: '#ffffff', fontSize: '13px'}}>Powered By &nbsp;<img src={tellko_logo} alt='' className='d-inline-block' style={{ width: '80px' }}></img></p>
              </div>
            </div>
          </div>

          {/* footer img */}
          <img src={footer_img} alt='' className='d-block w-100 mx-auto'></img>
          {/* footer img */}

        </div>
    );
};
